<template>
  <div class="full-area">
    <header
      class="question-header"
      :class="randomizedOptions.length < 5 ? 'align-bottom' : ''"
    >
      <h2>{{data.fields.title}}</h2>
    </header>

    <content class="content delay-entry">
      <div class="grid-wrapper">
        <div
          :span="12"
          v-for="box in randomizedOptions"
          :style="{'backgroundImage': `url(${box.fields.file.url})`}"
          :key="box.sys.id"
          class="binary-box"
          :class="{'standoutx': form.selected === box.fields.title || form.selected.includes(box.fields.title)}"
          @click="toggleThis(box.fields.title)"
        ><i class="el-icon-check icon-inside"></i></div>
      </div>
    </content>

    <SkipQuestionButton
      :align-left="validAnswers > 1"
      :disable-submit-button="!inputIsValid"
      :show-submit="validAnswers > 1"
      v-on:skip="skipQuestion()"
      v-on:submit="submitQuestion()"
    ></SkipQuestionButton>
  </div>
</template>

<script>
export default {
  name: 'Bilderset',

  props: [ 'data' ],

  components: {
    SkipQuestionButton: () => import('Components/base/SkipQuestionButton')
  },

  data () {
    return {
      form: {
        question: this.data.fields.title,
        id: this.data.sys.id,
        selected: [],
        timeToCompletion: null,
        timestamps: {
          start: new Date(),
          finish: null,
          valid: null
        }
      }
    }
  },

  computed: {
    randomizedOptions () {
      const options = this.data.fields.optionsImages
      return options.sort(function () { return 0.5 - Math.random() })
    },
    validAnswers () {
      if (this.data.fields.validAnswers <= this.data.fields.optionsImages.length) {
        return this.data.fields.validAnswers
      } else {
        return 1
      }
    },
    inputIsValid () {
      if (this.form.selected.length >= 1 && this.form.selected.length <= this.validAnswers) {
        return true
      } else {
        return false
      }
    }
  },

  methods: {
    skipQuestion () {
      this.form.selected = ['NS/NR']
      this.next()
    },
    submitQuestion () {
      this.next()
    },
    toggleThis (item) {
      if (!this.form.selected.includes(item)) {
        if (this.form.selected.length < this.validAnswers) {
          this.form.selected.push(item)
        }
      } else {
        this.form.selected = this.form.selected.filter(el => {
          return el !== item
        })
      }
    },
    next () {
      if (this.inputIsValid) {
        this.form.timestamps.valid = new Date()
        this.form.timeToCompletion = this.form.timestamps.valid.getTime() - this.form.timestamps.start.getTime()
      } else {
        return
      }
      this.form.timestamps.finish = new Date()
      this.$emit('next', this.form)
    }
  },

  watch: {
    // Add a simple watch to trigger next automatically after some ms
    'form.selected': function (newVal, oldVal) {
      if (this.inputIsValid && this.validAnswers === 1) {
        setTimeout(() => {
          this.next()
        }, 200)
      }
    }
  }
}
</script>

<style scoped lang="scss">
  .content {
    display: flex;
    flex: 1;
    justify-content: center;
    align-items: center;
    height: 100%;
    margin-bottom: 60px;

    @include breakpoint($micro) {
      margin-bottom: 30px;
    }
  }

  .binary-box {
    opacity: 0.9;
    transform: scale(1);
    transition: opacity ease-in-out 0.2s, transform 0.2s ease-in-out;
    position: relative;

    @include breakpoint($micro) {
      width: 40%;
      padding-bottom: calc(40% * 3/4);
      margin-bottom: calc(calc(100% - (40% * 2)) / 6);
      margin-top: calc(calc(100% - (40% * 2)) / 6);
    }
    &.standoutx {
      animation: standOut 0.4s ease-in-out;
      opacity: 1;
      transform: scale(1.05);

      .icon-inside {
        transform: scale(1);
        opacity: 1;
        transition: opacity 0.2s ease-in-out, transform 0.2s ease-in-out;
      }
    }
  }

  .icon-inside {
    opacity: 0;
    transform: scale(0.9);
    position: absolute;
    bottom: 5px;
    right: 5px;
    color: white;
    background: $color-emphasis-alt;
    border: 2px solid white;
    border-radius: 25px;
    width: 25px;
    height: 25px;
    font-size: 18px;
    font-weight: bold;
    text-align: center;
    margin: auto;
    display: flex;
    justify-content: center;
    align-items: center;
  }
</style>
